var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistBatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8836 5.52355L18.77 1.6371L19.4735 2.34062L14.5394 7.29226L11.7071 4.45999L12.41 3.7571L14.1764 5.52355L14.53 5.8771L14.8836 5.52355ZM16.0564 13.3535L18.2929 15.59L17.59 16.2929L15.3536 14.0564L15 13.7029L14.6464 14.0564L12.41 16.2929L11.7071 15.59L13.9436 13.3535L14.2971 13L13.9436 12.6464L11.7071 10.41L12.41 9.7071L14.6464 11.9435L15 12.2971L15.3536 11.9435L17.59 9.7071L18.2929 10.41L16.0564 12.6464L15.7029 13L16.0564 13.3535ZM0.5 5.49999V4.49999H8.5V5.49999H0.5ZM0.5 13.5V12.5H8.5V13.5H0.5Z",
    stroke: "#455B69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistBatch);
export default __webpack_public_path__ + "static/media/checklistBatch.29ae6ffa.svg";
export { ForwardRef as ReactComponent };